// extracted by mini-css-extract-plugin
export default {"entry":"JournalEntry_entry__LoOiI","entryText":"JournalEntry_entryText__pedRQ"};